import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import React from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  AttachMoney as AttachMoneyIcon,
  Payment as PaymentIcon,
  RequestQuote as RequestQuoteIcon,
  AccountBalance as AccountBalanceIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Sell as SellIcon,
  Assessment as AssessmentIcon,
  Schedule as ScheduleIcon,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface SidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const AccountingSidebar = ({
  open = false,
  toggle = () => {},
}: SidebarProps) => {
  const location = useLocation();

  const accountingMenuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/accounting" },
    {
      text: "Money Requests",
      icon: <AttachMoneyIcon />,
      path: "/accounting/moneyRequests",
    },
    { text: "Payments", icon: <PaymentIcon />, path: "/accounting/payments" },
    {
      text: "Charges",
      icon: <RequestQuoteIcon />,
      path: "/accounting/charges",
    },
    {
      text: "Lenders",
      icon: <AccountBalanceIcon />,
      path: "/accounting/lenders",
    },
    {
      text: "Loans",
      icon: <AccountBalanceWalletIcon />,
      path: "/accounting/loans",
    },
    { text: "Sales", icon: <SellIcon />, path: "/accounting/sales" },
    {
      text: "Hourly Paid Drivers",
      icon: <ScheduleIcon />,
      path: "/accounting/hourly-paid-drivers",
    },
    { text: "Reports", icon: <AssessmentIcon />, path: "/accounting/reports" },
  ];

  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <ResponsiveSidebar
      open={open}
      onClose={toggle}
      sx={(theme) => ({
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          boxSizing: "border-box",
          top: 64,
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          position: "fixed",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
        },
      })}
    >
      <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
        <IconButton
          onClick={toggle}
          aria-label={
            open ? "Close section navigation" : "Open section navigation"
          }
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
      <List>
        {accountingMenuItems.map((item) => {
          const button = (
            <ListItemButton
              key={item.text}
              selected={isSelected(item.path)}
              component={RouterLink}
              to={item.path}
              sx={{ justifyContent: open ? "initial" : "center" }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 0,
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          );
          return open ? (
            button
          ) : (
            <Tooltip key={item.text} title={item.text} placement="right">
              {button}
            </Tooltip>
          );
        })}
      </List>
    </ResponsiveSidebar>
  );
};

export default AccountingSidebar;
